import React from "react";
import { motion } from "framer-motion";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Item } from "features/preauthorization/components/NestedPayerResponse";
import { ageCalculator } from "helpers/utils";
import moment from "moment";

const ClaimRequestProvider = () => {
  return (
    <>
      <RequestDetails />
      <BeneficiaryDetails />
      <PhysicianInfo />
    </>
  );
};
export default ClaimRequestProvider;

const RequestDetails = () => {
  const { viewClaimInfo } = useSelector((state) => state.claim);

  const ClaimRequest = viewClaimInfo?.payload_json;

  const supInfoArray = Object.values(ClaimRequest?.sup_info || {});

  const visitReason = supInfoArray?.find((item) => item?.vreas)?.vreas || null;

  const providerReq = viewClaimInfo?.provider_request;

  const items = [
    {
      id: 1,
      title: "Request Date Time",
      value: providerReq?.req_time
        ? moment(providerReq?.req_time).format("DD-MM-YYYY HH:mm:ss")
        : "",
    },
    {
      id: 2,
      title: "Request Bundle Id",
      value: providerReq?.bundlereq_id || "",
    },
    {
      id: 3,
      title: `Claim Type`,
      value: viewClaimInfo?.claim_type,
    },
    {
      id: 4,
      title: `Preauthorization Sub Type`,
      value: viewClaimInfo?.claim_subtype,
    },
    {
      id: 5,
      title: "Visit Reason",
      value: visitReason || "",
    },

    {
      id: 66,
      title: "Prescription",
      value: ClaimRequest?.prescript_submt ? "Yes" : "No" || false,
    },

    {
      id: 6,
      title: "Transferal",
      value: "",

      value: ClaimRequest?.transferral ? "Yes" : "No" || false,
    },

    {
      id: 8,
      title: "Priority",
      value: ClaimRequest?.process_prior || "",
    },
  ]?.filter(Boolean);

  return (
    <motion.div
      style={{ border: "2px solid #d9f8eb" }}
      className="rounded p-3 position-relative mt-3 mb-3"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="position-absolute top-0 start-40 translate-middle-y px-2 d-none d-md-block">
        <span className="badge shadow-sm d-flex align-items-center justify-content-center gap-2 badge-subtle-success">
          <span className="fs-11">Claim Details</span>
        </span>
      </div>

      <Row>
        <Col xs={12}>
          <Row className="mt-1">
            {items?.map((item) => (
              <Col xs={6} md={4} xl={3} className="mb-3" key={item.id}>
                <Item title={item.title} value={item.value} />
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
    </motion.div>
  );
};

const BeneficiaryDetails = () => {
  const { viewClaimInfo } = useSelector((state) => state.claim);

  const claimRequest = viewClaimInfo?.payload_json;

  const providerReqPatient = viewClaimInfo?.provider_request?.patient;

  const itemDetails = [
    {
      id: 1,
      title: "Identity Type",
      value: providerReqPatient?.identity_type || "",
    },
    {
      id: 2,
      title: "Identity No",
      value: claimRequest?.patient_natid || "",
    },
    {
      id: 3,
      title: "Membership No",
      value: claimRequest?.patient_memid || "",
    },
    {
      id: 5,
      title: "Medical Record Number",
      value: claimRequest?.patient_mrn || "",
    },
    {
      id: 4,
      title: "Policy No",
      value: claimRequest?.patient_plynum || "",
    },
    { id: 6, title: "Class Name", value: claimRequest?.patient_clsnme || "" },
    {
      id: 6,
      title: "Policy Holder Name",
      value: claimRequest?.patient_polcyholdr || "",
    },
    {
      id: 7,
      title: "Martial Status",
      value: providerReqPatient?.maritalstatus || ''

      //   value: patientInfo?.maritalStatus,
    },
    {
      id: 8,
      title: "Occupation",
      value: claimRequest?.patient_profession || "",
    },
    {
      id: 9,
      title: "Religion",
      value: providerReqPatient?.religion || ''

      //   value: patientInfo?.religion,
    },
  ];

  const { age } = ageCalculator(claimRequest?.patient_dob);

  return (
    <motion.div
      style={{ border: "2px solid #d9f8eb" }}
      className="rounded p-3 position-relative mt-3 mb-3"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="position-absolute top-0 start-40 translate-middle-y px-2 d-none d-md-block">
        <span className="badge shadow-sm d-flex align-items-center justify-content-center gap-2 badge-subtle-success">
          <span className="fs-11">Beneficiary Details</span>
        </span>
      </div>

      <Row>
        <Col xs={12}>
          <Row>
            <Col xs={4} md={1}>
              <div className="position-relative d-inline-block">
                <img
                  src="/test-img.png"
                  alt="Patient"
                  className="img-fluid rounded-circle border"
                  style={{
                    width: "40px",
                    height: "40px",
                    objectFit: "cover",
                    border: "3px solid #2c7be5",
                  }}
                />
              </div>
            </Col>
            <Col xs={8} md={11}>
              <div className="d-flex flex-column">
                <span className="fs-10 fw-bold">{`${claimRequest?.patient_finame || ""
                  } ${claimRequest?.patient_faname || ""}`}</span>
                <span className="fs-10 text-600 fw-bold text-capitalize">
                  {age?.years || "0"} Years - {claimRequest?.patient_gender}
                </span>
              </div>
            </Col>
          </Row>
          <hr />
          <Row className="mt-1">
            {itemDetails?.map((item) => (
              <Col xs={6} md={4} xl={3} className="mb-3" key={item.id}>
                <Item title={item.title} value={item.value} />
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
    </motion.div>
  );
};

const PhysicianInfo = () => {
  // Get both claim and preauth data
  const { viewClaimInfo } = useSelector((state) => state.claim);

  const claimRequest = viewClaimInfo?.payload_json;

  const doctorsArr = viewClaimInfo?.provider_request?.practitioner || [];

  return (
    <motion.div
      style={{ border: "2px solid #d9f8eb" }}
      className="rounded p-3 position-relative mt-3 mb-3"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="position-absolute top-0 start-40 translate-middle-y px-2 d-none d-md-block">
        <span className="badge shadow-sm d-flex align-items-center justify-content-center gap-2 badge-subtle-success">
          <span className="fs-11">Physician Info</span>
        </span>
      </div>

      {doctorsArr?.map((item) => {
        return (
          <Row className="mt-3">
            <Col xs={12} md={3}>
              <div className="d-flex align-items-center gap-3">
                <div className="d-flex category-sevie1  badge-subtle-success justify-content-center align-items-center">
                  <div className="imgpatientnew2">
                    <i className="fas fa-user-md" />
                  </div>
                </div>
                <div className="text-capitalize fs-10 text-success fw-bold">
                  {item?.practitioner_name || "N/A"}
                </div>
              </div>
            </Col>
            <Col xs={12} md={3}>
              <Item title="Physician SCFHS" value={item?.practitioner_license} />
            </Col>
            <Col xs={12} md={3}>
              <Item title="Practice" value={item?.speciality_name} />
            </Col>
            <Col xs={12} md={3}>
              <Item title="Role" value={item?.practitioner_role} />
            </Col>
          </Row>
        );
      })}
    </motion.div>
  );
};
